/**
 * @description Renders the sync map field where the user selects which mapping to use when syncing their personnel file
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

/**
 * @prop mapList {{ id: number, name: string, syncOnSsn: boolean }} - the list of sync maps to choose from
 */
const SyncMapField = ({
  mapList
}) => {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      control={control}
      name='syncMap'
      render={({ field: { onChange, value } }) => {
        function handleChange (_, selection) {
          onChange(selection);
          setValue('syncOnSsn', selection.syncOnSsn);
        }

        return (
          <FormControl fullWidth required>
            <Autocomplete
              autoHighlight
              options={mapList}
              getOptionLabel={(option) => option.name}
              onChange={(evt, el) => handleChange(evt, el)}
              isOptionEqualToValue={(option) => option.name === value.name}
              disableClearable
              renderInput={(params) => (
                <TextField
                  // Autocomplete provides the list of params and passes it to TextField; both are third party libraries out of our control
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label='Select a mapping definition'
                />
              )}
              value={value ?? null}
            />
          </FormControl>
        );
      }}
      rules={{ required: true }}
    />
  );
};

SyncMapField.propTypes = {
  mapList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired
};

export default SyncMapField;
